import { Injectable, Optional, SkipSelf, TemplateRef } from '@angular/core';
import { ColorSchemes } from 'src/styles/color-scheme.type';

@Injectable({ providedIn: 'root' })
export class TemplateService {
  private templates = new Map<string, TemplateRef<any>>();
  private _colors: ColorSchemes = ColorSchemes.PRIMARY;

  public add(name: string, ref: TemplateRef<any>) {
    this.templates.set(name, ref);
  }

  constructor(@Optional() @SkipSelf() thisService?: TemplateService) {
    if (thisService) throw new Error('Multiple instances of TemplateService');
  }

  public set colors(c: ColorSchemes) {
    this._colors = c;
  }

  public get colors(): ColorSchemes {
    return this._colors;
  }

  // ? getters for easy access

  public get loader(): TemplateRef<any> {
    return this.templates.get('loader')!;
  }

  public get defaultRowTable(): TemplateRef<any> {
    return this.templates.get('defaultRowTable')!;
  }

  public get emptyDiv(): TemplateRef<any> {
    return this.templates.get('emptyDiv')!;
  }

  public get defaultRowTableHeader(): TemplateRef<any> {
    return this.templates.get('defaultRowTableHeader')!;
  }
}
